import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { IZipListItem } from '@/api/types-fip'

export const defaultFipZipData: IZipListItem = {
  zip: 0,
  stateCountyFips: 0,
  city: '',
  countyName: '',
  state: '',
  distance: 0
}

export interface IFipZips {
  FipZipList: IZipListItem[]
  FipZipSelected: (IZipListItem | null)
  StateFips: number
  CountyFips: number
}

@Module({ dynamic: true, store, name: 'FipZips', namespaced: true })
class FipZips extends VuexModule implements IFipZips {
  public FipZipList: IZipListItem[] = []
  public FipZipSelected: IZipListItem | null = null
  public StateFips = 0
  public CountyFips = 0

  @Mutation
  private DEL_ALL_ZIPLISTITEMS() {
    this.FipZipList = []
    this.StateFips = 0
    this.CountyFips = 0
  }

  @Mutation
  private LOAD_ZIPLISTITEMS(stateFips: number, countyFips: number, fipZips: IZipListItem[]) {
    this.FipZipList = fipZips
    this.StateFips = stateFips
    this.CountyFips = countyFips
  }

  // GETTERS
  get cachedFipZips() {
    return this.FipZipList
  }

  get countyFips() {
    return this.CountyFips
  }

  get stateFips() {
    return this.StateFips
  }

  @Action
  public loadFipZips(stateFips: number, countyFips: number, fipZips: IZipListItem[]) {
    this.DEL_ALL_ZIPLISTITEMS()
    this.LOAD_ZIPLISTITEMS(stateFips, countyFips, fipZips)
  }

  @Action
  public clearList() {
    this.DEL_ALL_ZIPLISTITEMS()
  }
}

export const FipZipModule = getModule(FipZips)
